var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('h2',{staticClass:"text-center mb-3"},[_vm._v(_vm._s(_vm.$t('heading.password_reset')))]),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('message.login_with_new_password')))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }